import { Component, ContentChildren, QueryList, Injector, AfterContentInit, Input, OnDestroy } from '@angular/core';
import { OptionComponent } from '../option/option.component';
import { Option } from '../option/option.model';
import { BaseControlValueAccessor } from '../../../core/base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

/**
 * Usage:
 *
 * <jhi-select name="civiliteSelect"
 *  [(ngModel)]="account.civilite" [label]="'Civilité'" [hiddenOptionLabel]="'Choisir une civilité'" required>
 *     <jhi-option value="Monsieur">Monsieur</jhi-option>
 *     <jhi-option value="Madame">Madame</jhi-option>
 *  </jhi-select>
 */

@Component({
  selector: 'jhi-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SelectComponent,
    multi: true
  }]
})
export class SelectComponent extends BaseControlValueAccessor implements AfterContentInit, OnDestroy {

  @Input()
  label: string;

  @Input()
  hiddenOptionLabel: string;

  @Input()
  id: string;

  @ContentChildren(OptionComponent)
  components: QueryList<OptionComponent>;

  value: any;

  options: Array<Option>;

  private subscription: Subscription;

  constructor(injector: Injector) {
    super(injector);
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();
    this.initOptions(this.components);
    this.subscription = this.components.changes.subscribe(components => {
      this.initOptions(components);
    })
  }

  ngOnDestroy(): void {
    if (this.subscription) {
        this.subscription.unsubscribe();
    }
    super.ngOnDestroy();
  }

  private initOptions(components: QueryList<OptionComponent>) {
    this.options = components.map(component => ({
      label: component.label,
      value: component.value,
      selected: this.isEquals(component.value, this.value),
      disabled: component.disabled
    }));
  }

  modelValueChanged(value: any): void {
    this.value = value;
    this.options.forEach(option => option.selected = this.isEquals(value, this.value));
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/select/select.component.ts